module.exports = __webpack_public_path__ + "img/attachment.59dbf573.svg";